define([
	"dojo/_base/declare",
	"csi/table/Delete",
	"csi/xml"
], function(declare,Delete,xml) {

return declare(Delete, {
		toWriter: function() {
			this.m_writer.changeParent(this.m_urlNode, "ColorPromos", xml.ATTR_REFLIST, [this.widget.getViewURL()], false);
		}
	});
});